import { Card } from 'antd';
import { StyledTable } from 'app/components/StyledTable/StyledTable';
import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { IAreaByCompanyListItem } from '../../slice/types';

interface IProps {
  data: IAreaByCompanyListItem[];
}

export const TaskCompaniesCard: FC<IProps> = ({ data }) => {
  const { t } = useTranslation();

  const columns = [
    {
      title: t('Common.Company', 'Company'),
      dataIndex: 'companyName',
      key: 'companyName',
      sorter: {
        compare: (a: IAreaByCompanyListItem, b: IAreaByCompanyListItem) => {
          return a.companyName.localeCompare(b.companyName);
        },
      },
    },
    {
      title: t('Task.Details.CompaniesTable.Area', 'Area'),
      dataIndex: 'readableArea',
      key: 'readableArea',
      width: '100px',
      sorter: {
        compare: (a: IAreaByCompanyListItem, b: IAreaByCompanyListItem) => {
          return a.area - b.area;
        },
      },
    },
  ];

  if (!data.length) {
    return null;
  }

  return (
    <Card bordered={false} style={{ marginTop: 12 }}>
      <StyledTable
        rowKey="id"
        dataSource={data}
        columns={columns}
        pagination={false}
        bordered={true}
      />
    </Card>
  );
};
